import { useEffect, useRef, useState } from "react";
import { _ProcessQueue } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_SM } from "../hooks/useModal";
import { FileService } from "../../../../core/services/FileService";
import { toast } from "react-toastify";
import { Modal } from "../Modal";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";

interface ComponentProps {
    idprocessqueue: number;
    onFinish?: () => void;
}

export const ValidationDocumentQueue = ({ idprocessqueue, onFinish }: ComponentProps) => {

    const { instance } = useDataBean(_ProcessQueue);
    const modal = useModal("Generando documento", MODAL_SM);

    const [doc, setDoc] = useState<string>("");
    const [fileType, setFileType] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const [finished, setFinished] = useState<boolean>(false);

    const file = new FileService();
    const intervalRef = useRef<any>(null);

    const stopPolling = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const getFileExtension = (filename: string) => {
        return filename?.split(".").pop()?.toLowerCase() || "";
    };

    const finishProcess = () => {
        stopPolling();
        setLoading(false);
        setFinished(true);
    };

    const getProcess = (id: number) => {
        console.log("🔄 Consultando proceso:", id);

        instance.getProcessQueue(id)
            .then((resp) => {

                if (resp?.Media) {
                    setDoc(file.getUrlFile(resp.MediaContext, resp.Media));
                    setFileType(getFileExtension(resp.Media));
                }

                if (resp?.State === 2) {
                    finishProcess();
                }

            })
            .catch((err) => {
                console.error("❌ Error en polling:", err);

                toast.error("❌ Error generando el documento");

                stopPolling();
                onFinish?.();
            });
    };

    useEffect(() => {
        if (!idprocessqueue) return;

        console.log("🚀 Iniciando proceso", idprocessqueue);

        stopPolling();

        setLoading(true);
        setFinished(false);
        setDoc("");

        modal.open();

        toast.info("⏳ Generando documento...", {
            toastId: `process-${idprocessqueue}`
        });

        getProcess(idprocessqueue);

        intervalRef.current = setInterval(() => {
            getProcess(idprocessqueue);
        }, 5000);

        return () => stopPolling();
    }, [idprocessqueue]);

    return (
        <Modal
            modal={modal.modal}
            updateModal={modal.setModal}
            evenOnClose={() => {
                console.log("🗑 Usuario canceló proceso");
                stopPolling();
                onFinish?.();
            }}
        >
            <div className="row">
                <div className="col-md-12">

                    {loading && (
                        <div className="text-center p-4">
                            <div className="spinner-border text-primary mb-3" />
                            <div>Generando documento, por favor espere...</div>
                        </div>
                    )}

                    {!loading && finished && !doc && (
                        <div className="text-center p-4 text-danger">
                            ❌ Documento no encontrado
                        </div>
                    )}

                    {!loading && doc && (
                        <VisorAnyDocument url={doc} type={fileType} />
                    )}

                </div>
            </div>
        </Modal>
    );
};